import { animate, stagger } from 'animejs';

function toggleMobileMenu() {
    const mobileMenuButton = document.getElementById('js__mobile-menu-button');
    const menuItems = document.querySelectorAll('#menu-mainmenu-mobile li');

    if (!mobileMenuButton || menuItems.length === 0) return;

    let isAnimating = false;

    mobileMenuButton.addEventListener('click', () => {
        if (isAnimating) return;

        const isOpen = document.body.classList.contains('mobilemenu-open');

        if (isOpen) {
            // Close animation
            isAnimating = true;

            animate(menuItems, {
                translateX: { from: '0%', to: '100%' },
                opacity: { from: 1, to: 0 },
                delay: stagger(100),
                duration: 150,
                ease: 'inOutQuad',
                onComplete: () => {
                    document.body.classList.remove('mobilemenu-open');
                    document.documentElement.classList.remove('noscroll');

                    isAnimating = false;
                }
            });

            return;
        }

        // Open animation
        document.body.classList.add('mobilemenu-open');
        document.documentElement.classList.add('noscroll');

        isAnimating = true;

        animate(menuItems, {
            translateX: { from: '-100%', to: '0%' },
            opacity: { from: 0, to: 1 },
            delay: stagger(100),
            duration: 250,
            ease: 'outQuad',
            onComplete: () => {
                isAnimating = false;
            }
        });
    });
}

function closeMenuOnLargeScreens() {
    if (window.innerWidth > 768) {
        document.body.classList.remove('mobilemenu-open');
        document.documentElement.classList.remove('noscroll');
    }
}

function persistMenuUnderlineDuringNavigation() {
    const navLinks = document.querySelectorAll('.main-menu a, .mobile-menu-list a');
    if (!navLinks.length) return;

    let pendingLink = null;
    const activatePending = (link) => {
        if (!link) return;
        if (pendingLink && pendingLink !== link) {
            pendingLink.classList.remove('is-nav-pending');
        }
        pendingLink = link;
        link.classList.add('is-nav-pending');
    };

    const handlePointer = (event) => {
        activatePending(event.currentTarget);
    };

    navLinks.forEach((link) => {
        link.addEventListener('mousedown', handlePointer);
        link.addEventListener('touchstart', handlePointer, { passive: true });
        link.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                activatePending(event.currentTarget);
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    toggleMobileMenu();
    persistMenuUnderlineDuringNavigation();
    window.addEventListener('resize', closeMenuOnLargeScreens);
});
